<app-loading *ngIf="loadingQuickStoryReport$ | async"></app-loading>

<form *ngIf="post" [formGroup]="formGroup">
  <div
    class="radio-buttons-holder"
    sui-radio-group
    formControlName="language"
    (valueChange)="setReportContent()"
  >
    <sui-radio value="english">
      {{ "post-quick-story.label.english" | translate }}
    </sui-radio>
    <sui-radio value="arabic">
      {{ "post-quick-story.label.arabic" | translate }}
    </sui-radio>
    <sui-radio value="bulgarian">
      {{ "post-quick-story.label.bulgarian" | translate }}
    </sui-radio>
  </div>
  <sui-button
    variant="primary"
    class="generate-btn"
    (click)="generateQuickStoryReport()"
  >
    {{ "post-quick-story.button.generate-report" | translate }}
  </sui-button>

  <div
    *ngIf="post?.quick_story_report?.[currentLanguageId]"
    class="toggle-area-holder"
  >
    <sui-textarea
      id="quick-story-report"
      formControlName="reportContent"
      [rows]="15"
    ></sui-textarea>
    <sui-button variant="secondary" (click)="updateReport()">
      {{ "post-quick-story.button.update-report" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="copyText()">
      {{ "btn.copy-to-clipboard" | translate }}
    </sui-button>
  </div>
  <div *ngIf="!post?.quick_story_report?.[currentLanguageId]" class="no-report">
    {{ "post-quick-story.text.no-report" | translate }}
  </div>
</form>
